import React from 'react';


export const MapCard = ({ mapId }) => {

  return (
    <div className={'rounded-lg overflow-hidden mt-4 w-full h-80'}>
      <iframe
        src={mapId}
        style={{ border: 0, width: '100%', height: '100%' }}
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      />
    </div>
  )
}